const HTML_RESPONSE_PATTERN = /<(?:!doctype\s+html|html|head|body)\b/i
const HTML_TITLE_PATTERN = /<title[^>]*>([\s\S]*?)<\/title>/i
const HTML_TAG_PATTERN = /<[^>]*>/g
const UNICODE_ESCAPE_PATTERN = /\\u([0-9a-f]{4})/gi
const WHITESPACE_PATTERN = /\s+/g

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function decodeUnicodeEscapes(value: string) {
  return value.replace(UNICODE_ESCAPE_PATTERN, (_, codePoint: string) =>
    String.fromCharCode(Number.parseInt(codePoint, 16)))
}

function nonBlankString(value: unknown) {
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : null
}

function extractHappydayResult(value: unknown) {
  if (!isRecord(value)) return null

  const result = isRecord(value.result) ? value.result : value
  const code = nonBlankString(result.resultCode)
  const message = nonBlankString(result.resultMsg)

  if (!code && !message) return null
  const decodedMessage = message ? decodeUnicodeEscapes(message) : null
  return [code, decodedMessage].filter(Boolean).join(' · ')
}

function summarizeHtmlResponse(value: string) {
  const title = value.match(HTML_TITLE_PATTERN)?.[1]
    ?.replace(HTML_TAG_PATTERN, '')
    .replace(WHITESPACE_PATTERN, ' ')
    .trim()

  return title
    ? `해피데이 서버 오류 · ${title}`
    : '해피데이 서버가 HTML 오류 응답을 반환했습니다.'
}

export function formatHappydayResponseMessage(rawMessage: string) {
  const message = rawMessage.trim()
  if (!message) return '해피데이 응답 내용이 없습니다.'

  try {
    const parsed: unknown = JSON.parse(message)
    const result = extractHappydayResult(parsed)
    if (result) return result
  } catch {
    // JSON이 아닌 응답은 HTML 또는 일반 텍스트로 처리한다.
  }

  if (HTML_RESPONSE_PATTERN.test(message)) {
    return summarizeHtmlResponse(message)
  }

  return decodeUnicodeEscapes(message)
}
